import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VendorListService {

  constructor() { }
  vendorValue = new BehaviorSubject(false);
}
